import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { User } from "@/models/user";
import { ConfigData } from "@/models/config";
import { setCookie } from "cookies-next";
import { ACCESS_TOKEN, ROLE, USER } from "@/constants/common";
import { UserSubscription } from "@/models/subscriptionUser";

export interface AuthState {
  user: User | null;
  configs?: ConfigData;
  verifiedSuccess?: boolean;
  email?: string;
  license?: UserSubscription | null;
  currencyLocal: string | null;
}

const initialState: AuthState = {
  user: null,
  license: null,
  currencyLocal: null,
};
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      state.license = action.payload?.license;
      state.currencyLocal = action.payload?.currency ?? "USD";
    },
    userLogoutRequest: (state) => {
      state.user = null;
      state.license = null;
      state.currencyLocal = null;
      setCookie(ACCESS_TOKEN, "", { maxAge: -1, path: "/" });
      setCookie(ROLE, null, { maxAge: -1, path: "/" });
      setCookie(USER, null, { maxAge: -1, path: "/" });
    },
    setUserLogin: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setConfigs: (state, action: PayloadAction<ConfigData>) => {
      state.configs = action.payload;
    },
    setEmail: (state, action: PayloadAction<string | undefined>) => {
      state.email = action.payload;
    },
    setCurrencyLocal: (state, action: PayloadAction<string | null>) => {
      state.currencyLocal = action.payload;
    },
  },
});

export const {
  updateUser,
  userLogoutRequest,
  setConfigs,
  setUserLogin,
  setEmail,
  setCurrencyLocal,
} = authSlice.actions;
export default authSlice.reducer;
